"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOSProperties = exports.getDeviceProperties = exports.getDeviceBrand = exports.getDeviceType = exports.getDevicePlatform = void 0;
var ua_parser_js_1 = require("ua-parser-js");
var getDevicePlatform = function (userAgent) {
    var userAgentValue = userAgent
        ? userAgent.toLowerCase()
        : window.navigator.userAgent.toLowerCase();
    var isWebView = userAgentValue.includes('wv');
    if (!isWebView) {
        return 'Web';
    }
    var isAndroid = userAgentValue.includes('android');
    if (isAndroid) {
        return 'Android';
    }
    return 'iOS';
};
exports.getDevicePlatform = getDevicePlatform;
var getDeviceType = function (userAgent) {
    var userAgentValue = userAgent
        ? userAgent.toLowerCase()
        : window.navigator.userAgent.toLowerCase();
    var parser = new ua_parser_js_1.UAParser(userAgentValue);
    var fallback;
    var device = parser.getDevice().type;
    var deviceType = device
        ? "".concat(device.charAt(0).toUpperCase()).concat(device.slice(1))
        : undefined;
    if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgentValue))
        fallback = 'Tablet';
    else if (/(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgentValue))
        fallback = 'Mobile';
    else
        fallback = 'Computer';
    return deviceType !== null && deviceType !== void 0 ? deviceType : fallback;
};
exports.getDeviceType = getDeviceType;
var getDeviceBrand = function (userAgent) {
    var _a, _b;
    var userAgentValue = userAgent !== null && userAgent !== void 0 ? userAgent : window.navigator.userAgent;
    var parser = new ua_parser_js_1.UAParser(userAgentValue);
    var result = parser.getResult();
    return (_b = (_a = result.device) === null || _a === void 0 ? void 0 : _a.vendor) !== null && _b !== void 0 ? _b : '';
};
exports.getDeviceBrand = getDeviceBrand;
var getDeviceProperties = function () {
    return {
        device_brand: (0, exports.getDeviceBrand)(),
        device_type: (0, exports.getDeviceType)(),
        device_platform: (0, exports.getDevicePlatform)(),
    };
};
exports.getDeviceProperties = getDeviceProperties;
var getOSProperties = function (userAgent) {
    var _a, _b;
    var userAgentValue = userAgent !== null && userAgent !== void 0 ? userAgent : window.navigator.userAgent;
    var parser = new ua_parser_js_1.UAParser(userAgentValue);
    var result_os = parser.getOS();
    return {
        os_version: (_a = result_os === null || result_os === void 0 ? void 0 : result_os.version) !== null && _a !== void 0 ? _a : 'Unknown OS version',
        os_name: (_b = result_os === null || result_os === void 0 ? void 0 : result_os.name) !== null && _b !== void 0 ? _b : 'Unknown OS name',
    };
};
exports.getOSProperties = getOSProperties;
//# sourceMappingURL=deviceUtils.js.map